export default (item) => {
  let fullname = []
  if(item.name){
    fullname.push(item.name)
  }
  if(item.lastname){
    fullname.push(item.lastname)
  }
  if(item.lastname2){
    fullname.push(item.lastname2)
  }
  return fullname.join(" ")
}



// WEBPACK FOOTER //
// ./src/filters/formatFullName.js